import React from "react";
import "./LoggedOut.scss";

const LoggedOut = () => (
	<div className="loggedOut">
		<a className="loggedOut-login" href="/login">
			Log In
		</a>
		<a className="loggedOut-signup" href="/signup">
			Sign Up
		</a>
	</div>
);

export default LoggedOut;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/LoggedOut.jsx